export enum SalesAccountStatus {
  "NEW" = "NEW",
  "STOPPED" = "STOPPED",
  "ACTIVE" = "ACTIVE",
}
